import { app } from '../../bootstrap/core';
import { forgotPasswordState } from './forgotPassword.state';
import { forgotPasswordComponent } from './forgotPassword.component';

app.config(forgotPasswordState);
app.component(forgotPasswordComponent.name, forgotPasswordComponent);
